var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.step.title))]),_c('Content',{key:_vm.language + _vm.selectedStep,attrs:{"file":_vm.step.file,"language":_vm.language}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }